import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { graphCache } from '../../../snippets/assuranceEngine/graphCache';
import { historicalData } from '../../../snippets/assuranceEngine/historicalData';
import { intentVerification } from '../../../snippets/assuranceEngine/intentVerification';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const assuranceEngineGroup = createFormSnippetGroup({
  snippets: {
    graphCache,
    historicalData,
    intentVerification,
  },
  render: ({ renderSnippet }) => (
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Assurance engine
      </div>
      <Card className='flex flex-col'>
        <SearchableSection
          id='assurance-engine'
          highlightOn={['assuranceEngine']}
          className='p'
        >
          <div className='text-default text-sm'>
            Disabling the options below can improve speed when creating &
            computing snapshots, however, it could have negative impact on
            product functionality.
          </div>
          <SearchableSection id='assurance-engine-graph-cache'>
            <div className='my'>{renderSnippet('graphCache')}</div>
          </SearchableSection>
          <SearchableSection id='assurance-engine-historical-data'>
            <div className='my'>{renderSnippet('historicalData')}</div>
          </SearchableSection>
          <SearchableSection id='assurance-engine-intent-verification'>
            <div className='mt'>{renderSnippet('intentVerification')}</div>
          </SearchableSection>
        </SearchableSection>
      </Card>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('assuranceEngine');
  },
});
